import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import GetLinkableLocation from 'features/organisation/views/organisation-details/components/electronic-client-record/components/link-room-modal/domain/models/get-linkable-location';

const baseUrl = '/api/v1/ElectronicClientRecord';

const getLinkableLocations = async (axiosInstance: AxiosInstance, organisationUnitId: string): Promise<GetLinkableLocation[]> => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/GetLocations/${organisationUnitId}`);
    return response.data;
  } catch (error) {
    throw new Error('Could not read linkable locations', { cause: error });
  }
};

interface Props {
  organisationUnitId: string;
}

export const useLazyGetLinkableLocationsQuery = ({ organisationUnitId }: Props): UseQueryResult<GetLinkableLocation[]> => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: ['GetLinkableLocations', organisationUnitId],
    queryFn: () => getLinkableLocations(authenticatedInstance, organisationUnitId),
    retry: false,
    enabled: false,
  });
};
